module.exports = __webpack_public_path__ + "static/media/bg-proteins_dt.51764143.jpg";